/**
 * @generated SignedSource<<637aedc37a8f0a8f96de6bae7ec235b0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ResultBuyingCreditsOperation = "FAILED" | "SUCCESS" | "SUCCESS_FOR_TRIAL" | "WAITING_FOR_APPROVAL";
export type ServicesWithCredits = "AI_STUDIO" | "AI_STUDIO_3D_MODEL_GENERATOR" | "AI_STUDIO_AD_GENERATOR" | "AI_STUDIO_MAGIC_SWAP" | "AI_STUDIO_MULTI_IMAGE_FUSION" | "AI_STUDIO_PRODUCT_STAGING" | "AI_STUDIO_UPSCALER" | "AI_STUDIO_VIDEO_GENERATOR" | "AI_STUDIO_VTO" | "GENERATIVE_AI" | "GENERATIVE_AI_DESIGN" | "GENERATIVE_AI_IMAGE_GENERATOR" | "GENERATIVE_AI_PRODUCT_STAGING" | "GENERATIVE_AI_VTO" | "TEST_ORDERS" | "VECTORIZE";
export type ServiceRechargeCreditsInput = {
  autoRefill: boolean;
  credits: number;
  currencyCode: string;
  expirationDate?: string | null;
  isForTrial?: boolean | null;
  isForTrialOnFirstPackage?: boolean | null;
  returnUrlFromApproval?: string | null;
  service: ServicesWithCredits;
  shopifyChargeID?: string | null;
};
export type useGenerationPreflightFirstPackMutation$variables = {
  input: ServiceRechargeCreditsInput;
};
export type useGenerationPreflightFirstPackMutation$data = {
  readonly buyServiceCredits: {
    readonly errorMessage: string | null;
    readonly result: ResultBuyingCreditsOperation;
  } | null;
};
export type useGenerationPreflightFirstPackMutation = {
  response: useGenerationPreflightFirstPackMutation$data;
  variables: useGenerationPreflightFirstPackMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ServiceBuyingResultOperation",
    "kind": "LinkedField",
    "name": "buyServiceCredits",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorMessage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useGenerationPreflightFirstPackMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useGenerationPreflightFirstPackMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "78fbb89a350d414913b3d2bb6c253061",
    "id": null,
    "metadata": {},
    "name": "useGenerationPreflightFirstPackMutation",
    "operationKind": "mutation",
    "text": "mutation useGenerationPreflightFirstPackMutation(\n  $input: ServiceRechargeCreditsInput!\n) {\n  buyServiceCredits(input: $input) {\n    result\n    errorMessage\n  }\n}\n"
  }
};
})();

(node as any).hash = "3efe104642ede0e4feb879374e7aeff3";

export default node;
